module.exports = __webpack_public_path__ + "static/media/23.3e264e54.png";